import { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const Trash: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M10.3619 14.0024H5.63799C4.85386 14.0024 4.20192 13.3986 4.14178 12.6168L3.49805 4.24829H12.5018L11.8581 12.6168C11.7979 13.3986 11.146 14.0024 10.3619 14.0024V14.0024Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3362 4.24827H2.66504"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M6.12434 1.99731H9.8759C10.2903 1.99731 10.6262 2.33324 10.6262 2.74763V4.24825H5.37402V2.74763C5.37402 2.33324 5.70995 1.99731 6.12434 1.99731V1.99731Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 8.10547L9.00083 9.89539"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.10547 10.0008L8.89539 8"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
